import { Rate } from 'antd'
import React from 'react'
import './index.css'
import { useNavigate } from 'react-router-dom';
import { useFormatMoney } from '../../Config/utils/formatCurrency';
import { buildTourDetailPath } from '../../Config/utils/tourUrlUtils';

const DestinationCard = (cardData) => {

    const { cardData: details } = cardData;
    const navigate = useNavigate()
    const formatMoney = useFormatMoney();
    const tags = Array.isArray(details?.tags) ? details.tags.slice(0, 2) : [];
    const priceUnitLabel = Number(details?.pricingModel) === 2 ? 'per unit' : 'per person';
    
    const destinationDetailHandler = () => {
        navigate(buildTourDetailPath(details));
    }

    return (
        <div className='flex flex-col items-start p-3 gap-2 cursor-pointer bg-[#FFFFFF] card-shadow h-full' onClick={() => destinationDetailHandler()}>
            <div className='destination-card__image h-[140px] w-full flex-shrink-0'>
                <img src={details.image} alt={details.title} loading='lazy' className='w-full h-full object-cover' />
                {tags.length > 0 && (
                    <div className='destination-card__tags'>
                        {tags.map((tag, index) => (
                            <span
                                key={tag}
                                className={`destination-card__tag destination-card__tag--${index === 0 ? 'red' : 'yellow'}`}
                            >
                                {tag}
                            </span>
                        ))}
                    </div>
                )}
            </div>
            <h3 className='font-semibold line-clamp-2 w-full'>{details.title}</h3>
            <p className='text-[#495560] break-words line-clamp-3 w-full flex-1'>{details.desc}</p>
            <div className='w-full border-b border-[#d5d9dd]'></div>
            <div className='flex justify-between items-center w-full mt-auto gap-2'>
                <div className='flex flex-col items-start min-w-0'>
                    <Rate
                        disabled
                        allowHalf
                        value={Number(details.rating) || 0}
                        className='destination-card__rate'
                    />
                    <span className='text-[#778088]'>{details.reviews} reviews</span>
                </div>
                <div className='flex flex-col items-end shrink-0'>
                    <span className='text-[#2ED1E1] font-bold text-base whitespace-nowrap'>{formatMoney(details.price, { style: 'symbol' })}</span>
                    <span className='text-[#778088] whitespace-nowrap'>{priceUnitLabel}</span>
                </div>
            </div>
        </div>
    )
}

export default DestinationCard
